import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { SnackbarService } from 'app/modules/shared/snackbar/service/snackbar.service';
import { environment } from 'environments/environment';
import { AppUpdateBannerComponent } from './app-update/app-update-banner.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LanguageService } from 'app/services/language.service';
import { LanguageCode } from 'app/statics/language-config';

@Component({
    selector: 'app-layout',
    imports: [
        RouterModule,
        HeaderComponent,
        FooterComponent,
        AppUpdateBannerComponent,
    ],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit {
    @ViewChild('sidenav') sidenav!: MatSidenav;
    enviromentName = environment.environmentName;
    showGlobalFooter = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private languageService: LanguageService,
        private snackbarService: SnackbarService
    ) {
        this.updateFooterVisibility(this.router.url);
    }

    ngOnInit(): void {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.updateFooterVisibility(event.urlAfterRedirects);
            }
        });

        this.route.queryParamMap.subscribe((params) => {
            const lang = params.get('lang');
            if (lang && Object.values(LanguageCode).includes(lang as LanguageCode)) {
                this.languageService.changeLanguage(lang as LanguageCode);
            }

            const warning = params.get('warning');
            if (warning) {
                this.snackbarService.open(warning, { type: 'warning' });
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: { warning: null },
                    queryParamsHandling: 'merge',
                    replaceUrl: true,
                });
            }
        });
    }

    private updateFooterVisibility(url: string): void {
        this.showGlobalFooter = !url.startsWith('/tireshop-list');
    }
}
